export default "__VITE_ASSET__c9e5f382__"